// extracted by mini-css-extract-plugin
export default {"code":"Code_code__kGEh4","codeBlock":"Code_codeBlock__NshTX"};